interface Props {
  height?: number;
  "aria-label"?: string;
}

/** Veritrellis logo — renders the full wordmark PNG. */
export const VeritrellisLogo = ({
  height = 36,
  "aria-label": ariaLabel = "Veritrellis"
}: Props) => {
  return (
    <img
      src="/logo-horizontal.svg"
      alt={ariaLabel}
      height={height}
      style={{ display: "block", width: "auto", height }}
    />
  );
};
